// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiTokenTdh {
    'id'?: number;
    'balance'?: number;
    'hodl_rate'?: number;
    'tdh'?: number;
    'tdh__raw'?: number;
    'days_held_per_edition'?: Array<number>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "balance",
            "baseName": "balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "hodl_rate",
            "baseName": "hodl_rate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "tdh",
            "baseName": "tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tdh__raw",
            "baseName": "tdh__raw",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "days_held_per_edition",
            "baseName": "days_held_per_edition",
            "type": "Array<number>",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiTokenTdh.attributeTypeMap;
    }

    public constructor() {
    }
}
